import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader, setCookie } from "../Helpers";
import {
	STR_ACCEPTED_RIDE_REQUESTS,
	STR_AGENCY_REPORTS,
	STR_AGENT_REQUESTS_HISTORY,
	STR_ALL_RIDE_REQUESTS,
	STR_CHANGE_PHONE_NUMBER,
	STR_CONSULTATION_FEE_PAYMENTS,
	STR_CONTACT_US,
	STR_COULD_NOT_PROCESS_REQUEST,
	STR_DEBTS_BALANCE,
	STR_LINK_SUPERVISOR,
	STR_LOGOUT,
	STR_MY_COACH,
	STR_MY_CREATED_AGENT_REQUESTS,
	STR_MY_PARTICIPATED_AGENT_REQUESTS,
	STR_MY_PROCESSED_AGENT_REQUESTS,
	STR_MY_REVENUES,
	STR_MY_STUDENTS,
	STR_MY_SUBSCRIPTION,
	STR_NO_DATA_FOUND,
	STR_OTHER_SETTINGS,
	STR_PAYMENT_SETTINGS,
	STR_PERSONAL_SETTINGS,
	STR_PLEASE_CONTACT_SUPPORT_TO_BECOME_RIDER,
	STR_RIDER_DASHBOARD,
	STR_SELECT_ACCOUNT_TO_MANAGE,
	STR_SET_CURRENCY,
	STR_SUBSCRIPTION_FEE_PAYMENTS,
	STR_TERMINATED_RIDE_REQUESTS,
	STR_UNACCEPTED_RIDE_REQUESTS,
	STR_UPDATE_PERSONAL_INFO,
	STR_UPDATE_USERNAME,
	STR_USER_REPORT,
	STR_VERIFY_YOUR_PROFILE,
	STR_WALLET_BALANCE,
	STR_WHATSAPP_SETUP,
	STR_YOUR_PROFILE,
	STR_YOUR_REPORTS
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdAnalytics, MdContactPage, MdCreditCard, MdDashboard, MdDetails, MdInfoOutline, MdLink, MdLogout, MdOutlineDashboard, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdOutlineSupport, MdOutlineWarning, MdPerson, MdSupervisorAccount, MdSupportAgent, MdTranslate, MdVerified, MdWallet, MdWhatsapp } from 'react-icons/md';
import { CgProfile } from "react-icons/cg";
import { GrCurrency } from "react-icons/gr";
import { GiTeacher } from "react-icons/gi";
import { FaRegUser } from "react-icons/fa";
import { RiListCheck2, RiListCheck3, RiListOrdered, RiProfileLine } from "react-icons/ri";
import { LiaUserSolid } from "react-icons/lia";
import { IoWarningOutline } from "react-icons/io5";
import OneRiderAccount from '../ones/OneRiderAccount';
import OneRideRequest from '../ones/OneRideRequest';

export default function View({ riderUuid }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [data, setData] = useState(null);
	const [summary, setSummary] = useState(null);

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			getRiderAllRideRequests(),
		])
		setReady(true);
	}

	async function getRiderAllRideRequests() {
		await callApi('get-rider-all-ride-requests', {  riderUuid }).then(response => {
			if(response.status === 1) {
				setData(response.data);
			} else {
				appContext.tellError(STR_COULD_NOT_PROCESS_REQUEST[appContext.language]);
			}
		})
	}

	

	useEffect(() => {
		init();
	}, [ riderUuid ])



	if (ready && data) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
					paddingBottom: "calc(var(--topBarHeight) + 40px)",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
													
							<h6 className="main-section-title">
								{STR_ALL_RIDE_REQUESTS[appContext.language]}
								
							</h6>
								
						</div>

						<div className="col-md-12">
							{
								(data.length > 0) ?
								data.map((item, i) => {
									return (
										<OneRideRequest key={i} data={item} />
									)
								})
								:
								<h6>
									{STR_NO_DATA_FOUND[appContext.language]}
								</h6>
							}
						</div>

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}